"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOADING_ANIMATION_SIZE = void 0;
var react_1 = __importDefault(require("react"));
var LOADING_ANIMATION_SIZE;
(function (LOADING_ANIMATION_SIZE) {
    LOADING_ANIMATION_SIZE["SMALL"] = "Small";
    LOADING_ANIMATION_SIZE["LARGE"] = "Large";
})(LOADING_ANIMATION_SIZE = exports.LOADING_ANIMATION_SIZE || (exports.LOADING_ANIMATION_SIZE = {}));
var Loader = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 200 200", className: className },
        react_1.default.createElement("radialGradient", { id: "a12", cx: ".66", fx: ".66", cy: ".3125", fy: ".3125", gradientTransform: "scale(1.5)" },
            react_1.default.createElement("stop", { offset: "0", stopColor: "#5482AB" }),
            react_1.default.createElement("stop", { offset: ".3", stopColor: "#5482AB", stopOpacity: ".9" }),
            react_1.default.createElement("stop", { offset: ".6", stopColor: "#5482AB", stopOpacity: ".8" }),
            react_1.default.createElement("stop", { offset: ".8", stopColor: "#5482AB", stopOpacity: ".3" }),
            react_1.default.createElement("stop", { offset: "1", stopColor: "#5482AB", stopOpacity: "0" })),
        react_1.default.createElement("circle", { 
            //@ts-ignore
            fill: "none", stroke: "url(#a12)", strokeWidth: "15", strokeLinecap: "round", strokeDasharray: "200 200", strokeDashoffset: "0", cx: "100", cy: "100", r: "70", style: { transformOrigin: "center" } },
            react_1.default.createElement("animateTransform", { type: "rotate", attributeName: "transform", calcMode: "spline", dur: "2", values: "360;0", keyTimes: "0;1", keySplines: "0 0 1 1", repeatCount: "indefinite" })),
        react_1.default.createElement("circle", { 
            //@ts-ignore
            transformOrigin: "center", fill: "none", opacity: ".1", stroke: "#5482AB", strokeWidth: "15", strokeLinecap: "round", cx: "100", cy: "100", r: "70" })));
};
var LoadingAnimation = function (_a) {
    var _b = _a.size, size = _b === void 0 ? LOADING_ANIMATION_SIZE.LARGE : _b;
    return (react_1.default.createElement("div", { className: "aligner" },
        react_1.default.createElement(Loader, { className: size === LOADING_ANIMATION_SIZE.LARGE
                ? "ui-loading-animation-large"
                : "ui-loading-animation-small" })));
};
exports.default = LoadingAnimation;
